import { render, staticRenderFns } from "./HyperlinkForModuleAmonestacion.vue?vue&type=template&id=b721bc10&scoped=true&functional=true&"
import script from "./HyperlinkForModuleAmonestacion.vue?vue&type=script&lang=js&"
export * from "./HyperlinkForModuleAmonestacion.vue?vue&type=script&lang=js&"
import style0 from "./HyperlinkForModuleAmonestacion.vue?vue&type=style&index=0&id=b721bc10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "b721bc10",
  null
  
)

export default component.exports